<template>

    <div>

        <transition leave-active-class="transition ease-in duration-1000"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0">

            <div class="text-sm"
                :class="{
                    'text-gray-600': type === 'normal',
                    'text-green-600': type === 'success',
                    'text-yellow': type === 'warning',
                    'text-red': type === 'danger',
                }"
                v-show="on" >

                <slot />

            </div>

        </transition>

    </div>
</template>

<script>

import { defineComponent } from 'vue'

export default defineComponent({

    props: {
        on: {
            type: Boolean
        },
        type: {
            type: String,
            default: 'normal'
        }
    },

})

</script>
